import { render, staticRenderFns } from "./CollapsiblePanel.vue?vue&type=template&id=2a34293e&scoped=true"
import script from "./CollapsiblePanel.vue?vue&type=script&lang=js"
export * from "./CollapsiblePanel.vue?vue&type=script&lang=js"
import style0 from "./CollapsiblePanel.vue?vue&type=style&index=0&id=2a34293e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a34293e",
  null
  
)

export default component.exports